import { useState } from "react";
import Time from "../Time/Time"
import { FormatedDate, Header, Nav, Wrapper, NavWrapper } from "./Calendar.styled"
import { format, addDays, subDays } from 'date-fns';
import useDateFnsLocale from "../../hooks/useDateFnsLocale";

type CalendarTypes = {
    onClickTime: () => void,
    shedule: { [key: string]: string[] },
    initialDate?: Date,
    localeCode?: string,
    className?: string,
    style?: React.CSSProperties,
    delegated?: React.HTMLAttributes<HTMLDivElement>,
    loadingFallback?: React.ReactNode,
    errorFallback?: (error: Error) => React.ReactNode,
}

const Calendar: React.FC<CalendarTypes> = ({ onClickTime, shedule, loadingFallback, errorFallback, initialDate = new Date(), localeCode = "en-US", className = "", style = {}, ...delegated }) => {
    const { loading, error, locale } = useDateFnsLocale(localeCode)
    const [date, setDate] = useState(initialDate)

    if (loading) return loadingFallback ?? <div>...loading</div>
    if (error) return errorFallback?.(error) ?? <div>{error.message}</div>

    return (
        <Wrapper className={className} style={style} {...delegated}>
            <Header>
                <FormatedDate>{locale ? format(date, "d MMMM yyyy", { locale: locale }) : format(date, "d MMMM yyyy" )}</FormatedDate>
                <NavWrapper>
                    <Nav onClick={() => setDate(initialDate)}>↻</Nav>
                    <Nav onClick={() => setDate(prev => subDays(prev, 1))}>ᐊ</Nav>
                    <Nav onClick={() => setDate(prev => addDays(prev, 1))}>ᐅ</Nav>
                </NavWrapper>
            </Header>
            <Time onClick={onClickTime} cells={shedule[format(date, "dd.MM.yyyy")]} />
        </Wrapper>
    )
}

export default Calendar